import React, { Component } from 'react';
import randomstring from 'uuid/v4';

import Node from './Node';

// eslint-disable-next-line
import style from './_style.css';

class Tree extends Component {
    state = {
        data: [],
    };

    static getDerivedStateFromProps(props, state) {
        if (props.tree !== state.data) {
            state.data = props.tree;
            return state;
        }
        return null;
    }

    render() {
        const { data } = this.state;
        return (
            <div className="category-tree">
                <ul>
                    <Node {...this.props} key={randomstring()} node={data}  renderNode={this.props.renderNode} />
                </ul>
            </div>
        );
    }
}

export default Tree;



// WEBPACK FOOTER //
// ./src/components/tree/Index.js